import css from './GroupDetail.module.css';
import ProfileInformation from './ProfileInformation';
import ChangePasswordForm from './ChangePasswordForm';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import { HugeiconsIcon } from '@hugeicons/react';
import { UserCircleIcon } from '@hugeicons-pro/core-bulk-rounded';

type BusinessDetailsProps = {
  variant?: 'page' | 'modal';
};

const BusinessDetails = ({ variant = 'page' }: BusinessDetailsProps) => {
  const isModal = variant === 'modal';

  return (
    <div className={isModal ? css.modalContainer : css.container}>
      {!isModal && <Breadcrumb />}
      {!isModal && (
        <div className={css.pageHeader}>
          <div className={css.pageHeaderLeft}>
            <div className={css.pageIconWrap}>
              <HugeiconsIcon icon={UserCircleIcon} size={22} color="#0b89ea" />
            </div>
            <div>
              <div className={css.pageTitle}>Profile</div>
              <div className={css.pageSubtitle}>Manage your account details and security.</div>
            </div>
          </div>
        </div>
      )}

      <div className={css.profileStack}>
        <ProfileInformation />
        <ChangePasswordForm />
      </div>
    </div>
  );
};

export default BusinessDetails;
